import Modal from "react-bootstrap/Modal";
import "../../../styles/modals.scss";
export default function SinglePOS({ image, ...props }) {
  return (
    <div className="sendpayment">
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <div className="modal-header justify-content-between d-flex  pointer">
            <h6>
              <b>POS Features</b>
            </h6>
          </div>
        </Modal.Header>
        <Modal.Body className="modalContent">
          <div className="single-pos-container">
            <center>
              <div className="image-section">
                <div className="selectedPOSImage">
                  <img src={image} alt="Mongoro POS" />
                </div>
              </div>
            </center>

            <div className="features">
              <h6>Features</h6>
              <ul>
                <li>
                  Smart technology locates the strongest available signal
                  wherever the patient is located
                </li>{" "}
                <li>
                  Smart technology locates the strongest available signal
                  wherever the patient is located
                </li>{" "}
                <li>
                  Smart technology locates the strongest available signal
                  wherever the patient is located
                </li>{" "}
                <li>
                  Smart technology locates the strongest available signal
                  wherever the patient is located
                </li>
              </ul>

              <button className="mo-active-btn">Request POS</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
